import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import AboutMe from "./components/AboutMe";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Resume from "./components/Resume";
import Contact from "./components/Contact";

export default function App() {
  // ── Theme Management ─────────────────────────────
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  // ── Active Section Tracking (Intersection Observer) ─────────────
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const ids = ["home","about","skills","experience","projects","services","resume","contact"];

    // mark contact active when user scrolls to bottom of page
    const handleScroll = () => {
      const scrolledToBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 50;
      if (scrolledToBottom) setActiveSection("contact");
    };
    window.addEventListener("scroll", handleScroll, { passive: true });

    const observers = ids.map((id) => {
      const el = document.getElementById(id);
      if (!el) return null;

      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setActiveSection(id);
        },
        { threshold: 0.1 }
      );

      obs.observe(el);
      return obs;
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      observers.forEach((o) => o?.disconnect());
    };
  }, []);

  return (
    <div className="bg-navy-950 text-slate-100">
      <Navbar active={activeSection} />
      <main>
        <section id="home"><Home /></section>
        <section id="about"><AboutMe /></section>
        <section id="skills"><Skills /></section>
        <section id="experience"><Experience /></section>
        <section id="projects"><Projects /></section>
        <section id="services"><Services /></section>
        <section id="resume"><Resume /></section>
        <section id="contact"><Contact /></section>
      </main>
      <footer className="py-6 text-center text-xs text-slate-600 border-t border-navy-800">
        © {new Date().getFullYear()} Nakarda Richards. All rights reserved.
      </footer>
    </div>
  );
}